(function () {
  // Lit la table { media_id: "Nom du coloris" } injectée dans la page
  function getMediaMap() {
    const el = document.querySelector('[data-variant-media-map]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  // Coche le bouton coloris dont la value correspond au nom donné
  function selectColorByName(name) {
    const radios = document.querySelectorAll('input[type="radio"][name^="Coloris"]');
    for (const radio of radios) {
      if (radio.value === name) {
        if (radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
    }
  }

  function onThumbClick(event) {
    const btn = event.target.closest('.slideshow-controls__thumbnail');
    if (!btn) return;
    const mediaId = btn.getAttribute('data-media-id');
    if (!mediaId) return;
    const map = getMediaMap();
    const colorName = map[mediaId];
    if (colorName) selectColorByName(colorName);
  }

  document.addEventListener('click', onThumbClick, true);
})();